import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFish, faScrewdriver, faWrench } from '@fortawesome/free-solid-svg-icons'
import { useAppUi } from '../../utils/useAppUi'
import { BRANDS } from '../../utils/brand'
import { getAppType } from '../../utils/appType'
import './MaintenancePage.scss'

const MaintenancePage = () => {
  useAppUi()

  return (
    <div className='maintenance-page'>
      <div className='maintenance-page__content'>
        <div className='maintenance-page__art'>
          <img
            src={BRANDS[getAppType()].mascot}
            alt='logo'
            className='maintenance-page__logo'
          />
          <span className='maintenance-page__z' aria-hidden>
            <i>z</i>
            <i>z</i>
            <i>Z</i>
          </span>
        </div>
        <h1 className='maintenance-page__title'>Mentenanță în desfășurare</h1>
        <p className='maintenance-page__subtitle'>
          Aplicația este temporar indisponibilă. Vă rugăm să reveniți în curând.
        </p>
        <div className='maintenance-page__tools' aria-hidden>
          <FontAwesomeIcon icon={faWrench} />
          <FontAwesomeIcon icon={faFish} />
          <FontAwesomeIcon icon={faScrewdriver} />
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
